export default {
    props: {
        moduleCode: String,
        identifyCode: String,
        keyCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            configurationList: [],
            queryLoading: false,
            saveLoading: false,
        }
    },
    methods: {
        getRemoteData() {
            return new Promise((resolve) => {
                this.queryLoading = true;
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/jscConfiguration/visibleList?identifyCode=${this.identifyCode}&key=${this.keyCode}`,
                    consoleLog: false
                }).then(res => {
                    this.configurationList = res;
                    resolve();
                }).finally(() => this.queryLoading = false);
            })
        },
        rename(id, title) {
            return new Promise((resolve, reject) => {
                this.saveLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ASSISTANT_URL + "/jscConfiguration/rename",
                    data: {
                        id: id,
                        title: title
                    },
                    commonErrorHandle: false,
                    consoleLog: false
                }).then(() => resolve())
                    .catch(e => reject(e))
                    .finally(() => this.saveLoading = false);
            })
        },
        deleteById(config) {
            return new Promise((resolve) => {
                this.saveLoading = true;
                this.$store.dispatch('api/delete', {
                    url: process.env.VUE_APP_EM_ASSISTANT_URL + "/jscConfiguration/deleteOne?id=" + config.id,
                    consoleLog: false
                }).then(() => resolve())
                    .finally(() => this.saveLoading = false);
            });
        },
    }
}
